// Card suits and values
export const SUITS = ['hearts', 'diamonds', 'clubs', 'spades'];
export const VALUES = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

const SPECIAL_VALUES = ['4', '9', '10', 'K', 'A'];

// Create a deck — difficulty adjusts special card frequency
// 'easy' = standard deck, 'normal' = standard, 'hard' = extra specials
export const createDeck = (difficulty = 'normal') => {
  const deck = [];
  SUITS.forEach(suit => {
    VALUES.forEach(value => {
      deck.push({
        id: `${value}_${suit}`,
        value,
        suit,
        faceUp: false
      });
    });
  });

  if (difficulty === 'hard') {
    // Add a second copy of all special cards (20 extra cards)
    SUITS.forEach(suit => {
      SPECIAL_VALUES.forEach(value => {
        deck.push({
          id: `${value}_${suit}_x`,
          value,
          suit,
          faceUp: false
        });
      });
    });
  }

  return deck;
};

// Shuffle deck using Fisher-Yates algorithm
export const shuffleDeck = (deck) => {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Deal cards to players
export const dealCards = (players, deck, cardsPerPlayer) => {
  const updatedPlayers = players.map(player => ({ ...player, hand: [] }));
  const remainingDeck = [...deck];
  
  // Deal cards round-robin style
  for (let round = 0; round < cardsPerPlayer; round++) {
    for (let playerIndex = 0; playerIndex < players.length; playerIndex++) {
      if (remainingDeck.length > 0) {
        const card = remainingDeck.pop();
        updatedPlayers[playerIndex].hand.push(card);
      }
    }
  }
  
  return { updatedPlayers, remainingDeck };
};

// Get card display name
export const getCardDisplayName = (card) => {
  const suitSymbols = {
    hearts: '♥',
    diamonds: '♦',
    clubs: '♣',
    spades: '♠'
  };
  
  return `${card.value}${suitSymbols[card.suit]}`;
};

// Get card color
export const getCardColor = (suit) => {
  return suit === 'hearts' || suit === 'diamonds' ? 'red' : 'black';
};
